import React from 'react';
import edit from '../../../../static/icons/edit.svg';
import trash from '../../../../static/icons/trash.svg';
import CellTrigger from '../../Menu/MenuTriggers/CellTrigger';
import { RootState } from '../../../../state/store/store';
import { connect } from 'react-redux';
import { businessPartner } from '../../../../models/entities/businessPartner/businessPartner';
import Menu from '../../Menu/Menu';
import MenuItem from '../../Menu/MenuItem';
import { singleBusinessPartnersSelectors } from '../../../../state/ducks/singleBusinessPartner/selectors';
type onRowMoreOptionClickType = () => void;
type deleteBusinessPartnerDocumentType = (businessPartnerId: string, documentId: string) => void;
type Props = {
    entityId: string;
    localization: any;
    onRowMoreOptionsClick?: onRowMoreOptionClickType;
    deleteBusinessPartnerDocument: deleteBusinessPartnerDocumentType;
    businessPartner?: businessPartner;
};

const BusinessPartnerDocumentMenu = ({ entityId, businessPartner, localization, onRowMoreOptionsClick, deleteBusinessPartnerDocument }: Props) => {
    const menuItems = [
        <MenuItem onClick={() => onRowMoreOptionsClick && onRowMoreOptionsClick()} icon={edit} text={localization.edit} />,
        <MenuItem
            onClick={() => businessPartner && deleteBusinessPartnerDocument(businessPartner.id, entityId)}
            icon={trash}
            text={localization.delete}
        />
    ];

    return <Menu options={menuItems} MenuTrigger={CellTrigger} strStyle="display: flex;align-items: center;width: 100%;height: 100%;" />;
};

const mapStateToProps = (state: RootState) => ({
    businessPartner: singleBusinessPartnersSelectors.businessPartner(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    deleteBusinessPartnerDocument: (businessPartnerId: string, documentId: string) =>
        dispatch.businessPartners.deleteBusinessPartnerDocument({ businessPartnerId, documentId }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BusinessPartnerDocumentMenu);
